// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__4zmlP","container":"Contact_container__J1LZ1","card":"Contact_card__uJftK","item":"Contact_item__j+P5X","items":"Contact_items__yAsTt"};